import { useState, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useStopwatch } from "react-timer-hook";

import Recorder from "../Recorder";

import Fab from "@mui/material/Fab";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import LinearProgress from "@mui/material/LinearProgress";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import DateTimePicker from "@mui/lab/DateTimePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Marker from "../Map/Marker";

import { uploadSonvi } from "../../store/actions/elements";
import { sendAlert } from "../../store/actions/alerts";
import { loadFile, validateNum } from "../../utils/fileManagement";
import {
  requestGeoLocation,
  syncDeviceLocation,
  updateGeo,
} from "../../store/actions/forms";

export default function UploadForm() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { uid } = useSelector((state) => state.authReducer);
  const { percentage } = useSelector((state) => state.formElements);
  const { lat, lng, zoom, locationLat, locationLng } = useSelector(
    (state) => state.formElements
  );

  const [disabled, setDisabled] = useState(false);
  const [date, setDate] = useState(new Date());
  const [category, setCategory] = useState("");
  const [audioFile, setAudioFile] = useState("audiofile");
  const [audioFileName, setAudioFileName] = useState("rec.mp3");
  const [audioType, setAudioType] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageType, setImageType] = useState("");
  const [imageFileName, setImageFileName] = useState("");
  const [sonviLat, setSonviLat] = useState("");
  const [sonviLng, setSonviLng] = useState("");
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [tags, setTags] = useState("");
  const [noiseLevel, setNoiseLevel] = useState("");
  const [mapRanges, setMapRanges] = useState({
    bounds: { ne: "", nw: "", se: "", sw: "" },
  });
  const { seconds, minutes, isRunning, start, pause, reset } = useStopwatch({
    autoStart: false,
  });
  useEffect(() => {
    if (uid === "") {
      console.log("user not logged");
      navigate("/mainMap");
    }
    setSonviLat(lat);
    setSonviLng(lng);
  }, [uid, navigate, lat, lng]);

  const handleMapClick = ({ lat, lng }) => {
    try {
      let latNum = parseFloat(lat);
      let lngNum = parseFloat(lng);
      if (-90 <= latNum && latNum <= 90 && -180 <= lngNum && lngNum <= 180) {
        setSonviLat(latNum);
        setSonviLng(lngNum);
      } else {
      }
    } catch (error) {
      const severity = "warning";
      const title = "Contenido";
      const content = "Favor de llenar todos los campos";
      dispatch(sendAlert({ severity, title, content }));
    }
  };

  const handleUploadSound = function (e) {
    loadFile(e, (fileString, fileName, fileType) => {
      setAudioType(fileType);
      setAudioFile(fileString);
      setAudioFileName(fileName);
    });
  };
  const handleUploadImage = (element) => {
    loadFile(element, (fileString, fileName, fileType) => {
      setImageType(fileType);
      setImageFile(fileString);
      setImageFileName(fileName);
    });
  };

  const handleSubmit = () => {
    const metaData = {
      uid,
      date,
      category,
      lat: sonviLat,
      lng: sonviLng,
      comment,
      noiseLevel,
      tags,
    };
    const data = {
      uid,
      audioType,
      audioFileName,
      imageFileName,
      imageType,
      imageFile,
      audioFile,
    };
    if (!validateNum(sonviLat, -180, 180) || !validateNum(sonviLat, -90, 90)) {
      setSonviLat("");
      setSonviLng("");
      return;
    }
    if (
      (uid, category && audioFile && imageFile && sonviLat && sonviLng && tags)
    ) {
      setDisabled(true);
      dispatch(uploadSonvi(metaData, data, navigate));
    } else {
      console.log("incomplete");
      console.log(metaData);
      const severity = "warning";
      const title = "Contenido";
      const content = "Favor de llenar todos los campos";
      dispatch(sendAlert({ severity, title, content }));
    }
  };

  const handleSearchCity = (event) => {
    event.preventDefault();
    dispatch(requestGeoLocation(name));
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: !fullScreen ? "row-reverse" : "column",
        justifyContent: "space-evenly",
      }}
    >
      <div>
        <Recorder
          handleStart={start}
          handleStop={pause}
          handleReset={reset}
          minutes={minutes}
          seconds={seconds}
          setAudio={(data) => {
            // SET FILE TYPE MP3
            // SET FILE NAME
            setAudioFile(data);
          }}
        />

        <Box
          component="form"
          sx={{
            widhth: "50%",
            margin: "5%",
          }}
          noValidate
          autoComplete="off"
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={4}>
              <FormControl fullWidth>
                <Stack spacing={4}>
                  <div
                    style={{ display: "flex", justifyContent: "space-around" }}
                  >
                    <label htmlFor="upload-audio">
                      <input
                        id="upload-audio"
                        name="upload-audio"
                        type="file"
                        accept="audio/wav, audio/mp3"
                        onChange={handleUploadSound}
                        style={{ display: "none" }}
                      />
                      <Fab color="primary" component="span" aria-label="add">
                        <UploadFileIcon />
                      </Fab>
                    </label>

                    <label htmlFor="upload-photo">
                      <input
                        id="upload-photo"
                        name="upload-photo"
                        type="file"
                        accept="image/jpg, image/jpeg"
                        onChange={handleUploadImage}
                        style={{ display: "none" }}
                      />
                      <Fab color="primary" component="span" aria-label="add">
                        <PhotoCameraIcon />
                      </Fab>
                    </label>
                  </div>
                  <Typography variant="p" component="p">
                    Audio seleccionado {audioFileName}
                  </Typography>
                  <Typography variant="p" component="p">
                    Imagen seleccionada {imageFileName}
                  </Typography>
                </Stack>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Categoría</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={category}
                  label="Categoría"
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <MenuItem value={"Sonidos Naturales"}>
                    Sonidos Naturales
                  </MenuItem>
                  <MenuItem value={"Sonidos humanos"}>Sonidos humanos</MenuItem>
                  <MenuItem value={"Sonidos mecánicos"}>
                    Sonidos mecánicos
                  </MenuItem>
                  <MenuItem value={"Sonidos y sociedad"}>
                    Sonidos y sociedad
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <Stack spacing={4}>
                  <DateTimePicker
                    label="Tiempo de captura"
                    value={date}
                    onChange={(e) => setDate(e)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <TextField
                    id="text-tags"
                    label="Etiquetas"
                    defaultValue=""
                    onChange={(e) => setTags(e.target.value)}
                  />
                  <TextField
                    id="text-comentarios"
                    label="Comentarios"
                    onChange={(e) => setComment(e.target.value)}
                    defaultValue=""
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <TextField
                      id="lat"
                      label="Latitud"
                      value={sonviLat}
                      onChange={(e) => setSonviLat(parseFloat(e.target.value))}
                    />
                    <TextField
                      id="lng"
                      label="longitud"
                      value={sonviLng}
                      onChange={(e) => setSonviLng(parseFloat(e.target.value))}
                    />
                    <TextField
                      id="noise"
                      label="Ruido dB"
                      defaultValue=""
                      onChange={(e) => setNoiseLevel(e.target.value)}
                    />
                  </Box>
                </Stack>
              </FormControl>
              <Button
                disabled={disabled}
                variant="contained"
                onClick={handleSubmit}
              >
                Cargar SONVI
              </Button>
              <LinearProgress variant="determinate" value={percentage} />
            </Stack>
          </LocalizationProvider>
        </Box>
        <Box
          component="form"
          sx={{
            widhth: "50%",
            margin: "5%",
            display: "flex",
            justifyContent: " space-around",
          }}
          onSubmit={handleSearchCity}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="city-search"
            label="Ciudad"
            defaultValue=""
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <Fab
            onClick={() => dispatch(syncDeviceLocation())}
            color="primary"
            aria-label="gps"
          >
            <GpsFixedIcon />
          </Fab>
        </Box>
      </div>
      <div style={{ height: "100vh", width: !fullScreen ? "50%" : "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API }}
          onClick={handleMapClick}
          onChange={(e) => {
            setMapRanges(e);
            dispatch(updateGeo(e.center.lat, e.center.lng, e.zoom));
          }}
          center={{ lat, lng }}
          zoom={zoom}
        >
          <Marker
            key={`current-location`}
            lat={locationLat}
            lng={locationLng}
            icon={"/red-dot.png"}
          />

          <Marker
            key={`${sonviLat}${sonviLng}`}
            lat={sonviLat}
            lng={sonviLng}
            icon={"/green-dot.png"}
          />
        </GoogleMapReact>
      </div>
    </div>
  );
}
